import React from "react";
import "./cardm.css";

export const Card = () => {
  return (
    <div className="photos">
      <div className="cards1">
        <img src="https://i.pinimg.com/236x/19/d2/ec/19d2ec0d6b13f9486f734663d66622e2.jpg" ></img>
        <img src="https://i.pinimg.com/236x/83/16/0c/83160c979f255974c5a1f3fa46044d27.jpg"></img>
        <img src="https://i.pinimg.com/236x/49/1c/80/491c801ca13b27bd8fcdbe7e387e3d52.jpg"></img>
        <img src="https://i.pinimg.com/236x/2e/dd/5a/2edd5a154f82622e57af82f5705a4e1d.jpg"></img>
        <img src="https://i.pinimg.com/236x/2e/dd/5a/2edd5a154f82622e57af82f5705a4e1d.jpg"></img>
        <img src="https://i.pinimg.com/236x/e0/51/3c/e0513c526bb9ca2f19d74c42eab3b20b.jpg"></img>
        <img src="https://i.pinimg.com/236x/43/f0/a0/43f0a0ba230717bf78fa4af2be557f4c.jpg"></img>
      </div>

      <div className="cards2">
        <img src="https://i.pinimg.com/236x/26/41/56/264156d5652feb267dcd8a893cd9de9f.jpg"></img>
        <img src="https://i.pinimg.com/236x/ce/e8/f7/cee8f7b2909a1246b93768baf35a6fac.jpg"></img>
        <img src="https://i.pinimg.com/236x/b8/aa/ef/b8aaefb865252a0cff2103dc5d0d8805.jpg"></img>
        <img src="https://i.pinimg.com/236x/80/c0/c4/80c0c4717d890c7468d7cb9a973c7cdf.jpg"></img>
        <img src="https://i.pinimg.com/236x/67/83/47/678347fa3e6abcebc7221d6c6244a06c.jpg"></img>
        <img src="https://i.pinimg.com/236x/bc/e1/d2/bce1d2b7a52f5701a6f286a09893dd1c.jpg"></img>
        <img src="https://i.pinimg.com/236x/0f/6b/44/0f6b44d564b0fdb6ea717c0d1b6f1bf0.jpg"></img>
      </div>
      <div className="cards3">
        <img src="https://i.pinimg.com/236x/85/be/84/85be844d616a32626c2f700a5a1fa268.jpg"></img>
        <img src="https://i.pinimg.com/236x/81/60/5a/81605af1d0ef4fa4caef8d6ffb7dcaf7.jpg"></img>
        <img src="https://i.pinimg.com/236x/82/ef/43/82ef43fb0f5ef9ccd2f54b5e4d962f33.jpg"></img>
        <img src="https://i.pinimg.com/236x/1c/92/ef/1c92ef3244674c66bb095d6a34a070f6.jpg"></img>
        <img src="https://i.pinimg.com/236x/94/81/d5/9481d588f37ffa59a41df06a547f0eab.jpg"></img>
        <img src="https://i.pinimg.com/236x/3d/cb/52/3dcb52bb824f52be29b9fa3d20fec92c.jpg"></img>
      </div>
      <div className="cards4">
        <img src="https://i.pinimg.com/236x/ca/51/3f/ca513f94d1bda368b947b8bc0ddf07b1.jpg"></img>
        <img src="https://i.pinimg.com/236x/b1/c4/68/b1c4684de3ebd855663da960a16ed785.jpg"></img>
        <img src="https://i.pinimg.com/236x/42/f2/3b/42f23b0f25a062e526f91337ec8050f9.jpg"></img>
        <img src="https://i.pinimg.com/236x/4c/36/cf/4c36cffe28850f9effb4c1d05f351b41.jpg"></img>
        <img src="https://i.pinimg.com/236x/34/70/4b/34704b5b673200225b6bdcf0642bc7eb.jpg"></img>
        <img src="https://i.pinimg.com/236x/ed/1d/fc/ed1dfcb8a3c9dcc747022b9692346e84.jpg"></img>
      </div>
      <div className="cards5">
        <img src="https://i.pinimg.com/236x/1b/0b/eb/1b0beba9e3f42d063dd61037e5dd8802.jpg"></img>
        <img src="https://i.pinimg.com/236x/a2/00/0d/a2000d49e03f8d6a48c8686042e5c0d0.jpg"></img>
        <img src="https://i.pinimg.com/236x/4a/d4/b5/4ad4b5733f46c1ee2f2fb7a546ff352c.jpg"></img>
        <img src="https://i.pinimg.com/236x/26/16/bb/2616bb184d8186691e1ff88340657802.jpg"></img>
        <img src="https://i.pinimg.com/236x/9d/67/70/9d67704b0c5946fde423aae65c811d1c.jpg"></img>
        <img src="https://i.pinimg.com/236x/c9/be/42/c9be42f64d162b556376370507a481d0.jpg"></img>
      </div>
    </div>
  );
};
